import React from 'react';
import { cn } from '../../../lib/utils';

const PainPointCards = ({
  value = [],
  onChange,
  className = '',
  disabled = false
}) => {
  const painPoints = [
    {
      id: 'finding_tickets',
      label: 'Struggling to find your tickets in emails or apps'
    },
    {
      id: 'remembering_events',
      label: 'Recalling events you\'ve attended'
    },
    {
      id: 'planning_friends',
      label: 'Planning with friends'
    },
    {
      id: 'discovering_events',
      label: 'Discovering new music events'
    },
    {
      id: 'selling_tickets',
      label: 'Selling unwanted tickets'
    },
    {
      id: 'finding_resale',
      label: 'Finding resale tickets'
    },
    {
      id: 'none',
      label: 'None of the above'
    }
  ];

  const handleToggle = (pointId) => {
    if (disabled) return;

    // Handle "None of the above" selection
    if (pointId === 'none') {
      onChange?.(['none']);
    } else {
      // Clear "none" if selecting other options
      const filteredValue = value.filter(id => id !== 'none');
      const newValue = filteredValue.includes(pointId)
        ? filteredValue.filter(id => id !== pointId)
        : [...filteredValue, pointId];

      onChange?.(newValue.length > 0 ? newValue : []);
    }
  };

  return (
    <div className={cn("space-y-2", className)}>
      {painPoints.map((point) => {
        const isSelected = value.includes(point.id);

        return (
          <button
            key={point.id}
            type="button"
            onClick={() => handleToggle(point.id)}
            disabled={disabled}
            className={cn(
              "w-full text-left px-4 py-3.5 rounded-lg",
              "border transition-all duration-200",
              "text-white/90 hover:text-white",
              "border-white/20",
              isSelected
                ? "bg-white/15 border-white/30"
                : "hover:bg-white/10",
              disabled && "opacity-50 cursor-not-allowed"
            )}
            aria-label={`${isSelected ? 'Deselect' : 'Select'} ${point.label}`}
            aria-pressed={isSelected}
          >
            <span className="text-[15px] leading-relaxed">{point.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default PainPointCards;